import {
  DebriefV2OutcomeResult,
  type GetDebriefFactsApiRequest,
} from '@momentum/types';
import type { DescribeState } from '../types/describe.types';

export function toAnswersPayload(
  state: DescribeState
): GetDebriefFactsApiRequest {
  if (!state.goal || !state.outcome || !state.date || !state.people) {
    throw new Error(
      'toAnswersPayload called before all four core answers were captured'
    );
  }

  return {
    answers: {
      goal: state.goal.description,
      outcome: {
        result:
          state.outcome.result === 'achieved'
            ? DebriefV2OutcomeResult.Achieved
            : DebriefV2OutcomeResult.NotAchieved,
        context: state.outcome.context,
      },
      startDate: state.date.startDate,
      endDate: state.date.endDate,
      people: {
        employeeIds: state.people.employees.map((employee) => employee._id),
      },
    },
  };
}
